import { api } from '../../services/api/client';

const SESSION_FLAG = 'cuantrader_location_sent';

interface GpsPayload {
  lat: number;
  lng: number;
  country?: string;
  region?: string;
  city?: string;
}

async function reverseGeocode(lat: number, lng: number): Promise<Partial<GpsPayload>> {
  try {
    const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=id`;
    const res = await fetch(url);
    const d = await res.json();
    return {
      country: d.countryName || '',
      region: d.principalSubdivision || '',
      city: d.city || d.locality || '',
    };
  } catch {
    return {};
  }
}

function getGps(): Promise<GeolocationPosition | null> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(pos),
      () => resolve(null),
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
    );
  });
}

/**
 * Capture the member's location once per browser session.
 * Tries browser GPS (with permission); on denial/unavailability the backend
 * falls back to IP-based geolocation. Best-effort, never throws.
 */
export async function captureLocationOnce(): Promise<void> {
  try {
    if (sessionStorage.getItem(SESSION_FLAG)) return;
    sessionStorage.setItem(SESSION_FLAG, '1');

    const pos = await getGps();
    if (pos) {
      const { latitude, longitude } = pos.coords;
      const geo = await reverseGeocode(latitude, longitude);
      await api.post('/member/location', {
        lat: latitude,
        lng: longitude,
        country: geo.country,
        region: geo.region,
        city: geo.city,
      });
    } else {
      // No GPS → backend geolocates from IP
      await api.post('/member/location', {});
    }
  } catch {
    // best-effort only
  }
}
